// extracted by mini-css-extract-plugin
export default {"chat-empty":"Tnjr0G3sHth3NtV","banner":"iNlOfTrk17t5PLi","icon":"HJFuuqeSDzmQX9F","title":"FLwBJ2mnYeFAItn","subtitle":"LLZlTn7JS9dTiJx"};